var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      attrs: {
        "append-to-body": true,
        title: _vm.eventApprovalTitle,
        visible: _vm.eventApprovalDrawer,
        "custom-class": "drawerClass",
        direction: "ltr",
        size: "1000px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.eventApprovalDrawer = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "warpContent" },
        [
          _c(
            "el-descriptions",
            { attrs: { colon: false, column: 5, direction: "vertical" } },
            [
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("fixDutyFine.eventCategory") } },
                [_c("div", [_vm._v(_vm._s(_vm.rowObj.eventTypeName || "--"))])]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("fixDutyFine.abnormalityType") } },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.rowObj.exceptionTypeName || "--")),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("fixDutyFine.abnormalityLevel") } },
                [
                  _c(
                    "div",
                    {
                      style: {
                        color: _vm.rowObj.exceptionLevel === 1 ? "red" : "",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.rowObj.exceptionLevelName || "--") +
                          " "
                      ),
                    ]
                  ),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("fixDutyFine.estimatedLossAmount") } },
                [
                  _c("div", [
                    _vm._v(_vm._s("R$ " + _vm.rowObj.financeLoss || "--")),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("fixDutyFine.casualtyCount") } },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.rowObj.lossPeopleQuantity || 0)),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                {
                  attrs: { label: _vm.$t("fixDutyFine.affectedPackageCount") },
                },
                [_c("div", [_vm._v(_vm._s(_vm.rowObj.waybillQuantity || 0))])]
              ),
              _c(
                "el-descriptions-item",
                {
                  attrs: {
                    label: _vm.$t("fixDutyFine.abnormalityDescription"),
                    span: 4,
                  },
                },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.rowObj.exceptionDetail || "--")),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                {
                  attrs: {
                    label: _vm.$t("fixDutyFine.hasPoliceReceipt"),
                    span: 2,
                  },
                },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.rowObj.policeReceiptName || "--")),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("fixDutyFine.hasMDFE"), span: 2 } },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.rowObj.mdfeInvoiceName || "--")),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("fixDutyFine.hasElectronicLock") } },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.rowObj.electronicLockName || "--")),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("fixDutyFine.photos"), span: 5 } },
                [
                  _vm.rowObj.photoList
                    ? _c(
                        "div",
                        {
                          staticClass: "demo-image__preview",
                          staticStyle: { "z-index": "9999" },
                        },
                        _vm._l(_vm.rowObj.photoList, function (item2, index2) {
                          return _c("el-image", {
                            key: index2,
                            staticStyle: {
                              width: "100px",
                              "margin-right": "5px",
                            },
                            attrs: {
                              "preview-src-list": [item2],
                              src: item2,
                              fit: "contain",
                            },
                          })
                        }),
                        1
                      )
                    : _c("div", [_vm._v("--")]),
                ]
              ),
              _vm.isEvent
                ? _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("home.appliveResult"), span: 5 } },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.approveStatus,
                                callback: function ($$v) {
                                  _vm.approveStatus = $$v
                                },
                                expression: "approveStatus",
                              },
                            },
                            [
                              _c(
                                "el-radio",
                                {
                                  staticStyle: { "font-weight": "bold" },
                                  attrs: { label: 1 },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("customerManagements.approved")
                                    ) + " "
                                  ),
                                ]
                              ),
                              _c(
                                "el-radio",
                                {
                                  staticStyle: { "font-weight": "bold" },
                                  attrs: { label: 2 },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("orderCenterCont.ReviewFailed")
                                    ) + " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.approveStatus === 1 && _vm.isEvent
                ? _c(
                    "el-descriptions-item",
                    {
                      attrs: {
                        label: _vm.$t("fixDutyFine.excludeFromTimeliness"),
                        span: 5,
                      },
                    },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.removeAging,
                                callback: function ($$v) {
                                  _vm.removeAging = $$v
                                },
                                expression: "removeAging",
                              },
                            },
                            [
                              _c(
                                "el-radio",
                                {
                                  staticStyle: { "font-weight": "bold" },
                                  attrs: { label: 0 },
                                },
                                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.No")))]
                              ),
                              _c(
                                "el-radio",
                                {
                                  staticStyle: { "font-weight": "bold" },
                                  attrs: { label: 1 },
                                },
                                [_vm._v(_vm._s(_vm.$t("GlobalSetObj.yes")))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm.isEvent
            ? _c(
                "div",
                {
                  staticStyle: { "text-align": "right", "margin-top": "20px" },
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.eventApprovalDrawer = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("GlobalSetObj.cancel")))]
                  ),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.confirm } },
                    [_vm._v(_vm._s(_vm.$t("trajectory.submit")))]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }